import styles from './InviteButton.module.scss';

import { ForwardToInbox } from '@mui/icons-material';
import { Button, Stack, Theme, Typography, useMediaQuery } from '@mui/material';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import { EntityPickerPopover } from '@work4all/components/lib/components/entity-picker/components';
import { MailboxPicker } from '@work4all/components/lib/components/entity-picker/mailbox-picker/MailboxPicker';
import { Option } from '@work4all/components/lib/components/split-button/SplitButton';

import { useSendAppointmentInvites } from '../../hooks/use-send-invites';

export enum InviteButtonValue {
  INVITE = 'INVITE',
  SAVE = 'SAVE',
}

export type InviteButtonOption = Option & { id: InviteButtonValue };

interface IProps {
  onClick: (option: InviteButtonValue) => void;
  disabled?: boolean;
}

export const InviteButton = (props: IProps) => {
  const { t } = useTranslation();
  const { onClick } = props;

  const { appointmentInviteMailbox, setAppointmentInviteMailbox } =
    useSendAppointmentInvites();

  const isMobile = useMediaQuery<Theme>((theme) =>
    theme.breakpoints.down('sm')
  );

  return (
    <Stack direction="row" gap="1rem" alignContent="center">
      <Stack alignItems="center" gap="0.5rem">
        {appointmentInviteMailbox && (
          <EntityPickerPopover
            picker={
              <MailboxPicker
                value={null}
                onChange={(e) => {
                  setAppointmentInviteMailbox(e.smtpAddress);
                }}
                multiple={false}
              />
            }
          >
            <Stack
              className={clsx(styles.mailboxSelector, {
                [styles.mobile]: isMobile,
              })}
            >
              <Typography variant="caption" color="var(--text03)">
                {t('COMMON.FROM').toLowerCase()}:
              </Typography>
              <Typography
                variant="caption"
                color="var(--brand01)"
                overflow="hidden"
                whiteSpace="nowrap"
                textOverflow="ellipsis"
              >
                {appointmentInviteMailbox}
              </Typography>
            </Stack>
          </EntityPickerPopover>
        )}
        <Button
          startIcon={<ForwardToInbox />}
          {...props}
          onClick={() => {
            onClick(InviteButtonValue.INVITE);
          }}
          variant="contained"
        >
          {t('INPUTS.INVITE')}
        </Button>
      </Stack>
    </Stack>
  );
};
